export enum RenderType {
  Static = 1,
  Dynamic = 2
}
